import { RouteType } from 'types/RouteType';
import { ServiceStoreType } from 'types/ServiceStoreTypes';

const userManagementRoute: RouteType[] = [
  {
    name: 'User Management',
    path: '/user-management',
    layout: '/app',
    viewportCard: {
      header: {
        title: 'User Management',
        component: () => import('./UserManagement.Header'),
        enableRefreshButton: true,
        enableBackButton: true,
      },
      body: {
        component: () => import('./UserManagement.Body'),
      },
    },
    group: 'Administration',
    hidden: false,
    requiresAuth: true,
    requiresPermission: false,
    requiresAdmin: true,
    enableAutoFind: false,
    channels: ['user', 'role-permissions'],
    onEnter: async ({ rootStore }) => {
      const userStore = rootStore.userStore as ServiceStoreType;
      userStore.find();

      const rolePermissionsStore = rootStore.rolePermissionsStore as ServiceStoreType | undefined;
      if (rolePermissionsStore?.find) {
        rolePermissionsStore.find({ query: { appName: rootStore.appName, $limit: 5000 } });
      }
    },
  },
];

export default userManagementRoute;
